<template>
  <div style="height: 100%">
    <PickerPane :getListMethod="getMachineListFromFilter" :locked-filters="mixedFilters" :paginationEnabled="true"
      :show-filter-tab="true" :show-sorting-tab="false" :itemsPerPage="40" :pk="'M-PP'" :hideCheckboxesOnItems="false"
      :groupBy="groupByUnitFunction"
      :title="multiple ? $t('servicesystem.common_objects.machine.select_machines') : $t('servicesystem.common_objects.machine.select_machine')"
      :multiple="multiple" :allowSelectAll="allowSelectAll" :previewable="true" :closeable="closeable"
      :scrollcheckTrigger="scrollcheckTrigger" :createNewFunction="createNew" :preSelected="preSelected" ref="picker"
      :quickClickFunction="quickClickFunction" :onMiddleClick="openInNewTab" @select="sf => handleSelect(sf)">

      <template v-slot:preview="{ item }">

        <PreviewMachine :id="item.Id" :customerId="customerId ? customerId : item.CustomerId">

          <template v-slot:header>
            <v-toolbar dense flat class="minitoolbar">
              <v-btn icon small class="mr-2" @click="closePreview">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <h4 class="mt-1">{{ item.DisplayName }}</h4>
              <v-spacer />
              <MachineSelectionOptions :selectMethod="() => selectItem(item)" :selectText="selectText"
                :customerId="customerId ? customerId : item.CustomerId" :clearSelectionMethod="closePreview"
                :refreshListMethod="refreshList" :top="false" :openInNewTabFunc="() => openInNewTab(item)">
              </MachineSelectionOptions>
            </v-toolbar>
          </template>

        </PreviewMachine>
      </template>

      <template v-slot:group-header="{ group, items, selectionFilter, setSelectionFilter }">
        <MachineListUnitSubHeader :unit="group" :items="items" :multiple="multiple" :selectionFilter="selectionFilter"
          :setSelectionFilterFunc="setSelectionFilter" @checkScroll="scrollcheckTrigger++">
        </MachineListUnitSubHeader>
      </template>

      <template v-if="groupByUnitBool"
        v-slot:list-item-wrapper="{ item, index, handleadded, handlechanged, previewable, isPreviewed, showCheckbox, isChecked,
          toggleCheckbox, openPreview, closePreview, handleItemClick, handleMiddleClick, selectionFilter, setSelectionFilter }">
        <SelectableListItemWrapper :index="index" :item="item" :previewable="previewable" :isPreviewed="isPreviewed"
          :showCheckbox="showCheckbox" :isChecked="isCheckedByUnitOrSelf(item, isChecked, selectionFilter)"
          :toggleCheckbox="() => toggleSelectItemUnitContext(item, selectionFilter, setSelectionFilter)"
          :openPreview="openPreview" :closePreview="closePreview" :hide="hideByUnitId(selectionFilter, item.UnitId)"
          @PrimaryClick="handleItemClick(item)" @MiddleClick="handleMiddleClick(item)">
          <template v-slot:list-item>
            <ListItem :machine="item" :class="multiple ? 'px-1' : ''" style="max-width: 100%;" compact
              @Update="handlechanged">
            </ListItem>
          </template>
        </SelectableListItemWrapper>
      </template>
      <template v-else v-slot:list-item="{ item, handlechanged }">
        <ListItem :machine="item" :class="multiple ? 'px-1' : ''" style="max-width: 100%;" compact
          @Update="handlechanged">
        </ListItem>
      </template>

      <template
        v-slot:select-actions="{ selectionFilter, filter, selectMethod, clearSelectionMethod, refreshListMethod }">
        <MachineSelectionOptions :selectionFilter="selectionFilter" :filter="filter" :selectMethod="handleSelect"
          :customerId="customerId" :clearSelectionMethod="clearSelectionMethod" :refreshListMethod="refreshListMethod"
          :selectText="selectText">
        </MachineSelectionOptions>
      </template>

    </PickerPane>
    <CreateNewMachineDialog ref="createMachineDialog">
    </CreateNewMachineDialog>
  </div>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
//import ListItem from "@/components/ListItems/UnitMachineListItems.vue";
import ListItem from "@/components/ListItems/MachineListItem2.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import PickerPane from "@/views/pim/articles/PickerPane.vue";
import PreviewMachine from "@/components/Sections/Panes/PreviewMachine.vue";
import CreateNewMachineDialog from "@/components/Dialogs/CreateMachineDialog.vue";
import MachineSelectionOptions from "@/views/job/newjob/cards/machines/MachineSelectionOptions.vue";
import MachineListUnitSubHeader from "@/components/ListItems/MachineListUnitSubHeader.vue";
import SelectableListItemWrapper from "@/components/ListItems/SelectableListItemWrapper.vue";

export default {
  name: "MachinePickerPane",
  props: {
    closeable: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    lockedFilters: Object,
    preSelected: Array,
    allowSelectAll: Boolean,
    customerId: String,
    selectText: String,
    onCreated: Function,
    quickClickFunction: Function,
    onSelectMethod: Function,
  },
  components: {
    PickerPane,
    ListItem,
    PreviewMachine,
    MachineSelectionOptions,
    CreateNewMachineDialog,
    MachineListUnitSubHeader,
    SelectableListItemWrapper,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "ML-PP-",
      scrollcheckTrigger: 1,
    };
  },

  methods: {
    isCheckedByUnitOrSelf(item, isChecked, selectionFilter) {
      const unitInMap = selectionFilter.unitIdMap?.[item.UnitId];
      if (!unitInMap) {
        return isChecked;
      }
      else {
        //if unit in map and select all, check if id is excluded
        if (!selectionFilter.SelectAll) {
          var isExcluded = selectionFilter.excludeItemIdMap?.[item.Id];
          //console.log("unitInMap: ", unitInMap, "Excluded item id: ", item.Id, isExcluded);
          return !isExcluded;
        }
        //unit in map and not select all, check if id is prepended
        else {
          var isPrepended = selectionFilter.prependItemIdMap?.[item.Id];
          //console.log("unitInMap: ", unitInMap, "Prepended item id: ", item.Id, isPrepended);
          return isPrepended;
        }
      }
    },

    hideByUnitId(selectionFilter, unitId) {
      return selectionFilter.hideByUnitId?.[unitId] ?? false;
    },

    toggleSelectItemUnitContext(item, selectionFilter, setSelectionFilterFunc) {
      var copy = Object.assign({}, selectionFilter);

      var writeToExclude = copy.SelectAll;
      const unitInMap = copy.unitIdMap?.[item.UnitId];
      if (unitInMap) {
        writeToExclude = !writeToExclude;
      }

      if (writeToExclude) {
        copy.excludeItemIdMap = { ...copy.excludeItemIdMap, [item.Id]: !copy.excludeItemIdMap?.[item.Id] };
        copy.ExcludeItemIdList = Object.keys(copy.excludeItemIdMap).filter(k => copy.excludeItemIdMap[k]);
      }
      else {
        copy.prependItemIdMap = { ...copy.prependItemIdMap, [item.Id]: !copy.prependItemIdMap?.[item.Id] };
        copy.PrependItemIdList = Object.keys(copy.prependItemIdMap).filter(k => copy.prependItemIdMap[k]);
      }

      setSelectionFilterFunc(copy);
    },

    async selectItem(item) {
      var selectionFilterdto = {
        AllSelected: false,
        PrependItemIdList: [item.Id],
        InitialListFilter: { ...this.lockedFilters },
      };
      await this.handleSelect(selectionFilterdto);
    },

    async handleSelect(selectionFilter) {
      if (this.onSelectMethod) {
        await this.onSelectMethod(selectionFilter);
      }
      else {
        await this.defaultOnSelectMethod(selectionFilter);
      }
    },

    async defaultOnSelectMethod(selectionFilter) {
      this.$emit("select", selectionFilter);
    },

    async createNew() {
      var result = await this.$refs.createMachineDialog.show({
        title: "Create Machine",
        customerId: this.customerId ?? null,
        //customerList: this.Customer ? [this.Customer] : this.customerList,
      });
      if (result) {
        this.onCreated !== undefined ? this.onCreated(result) : this.refreshList();
      }
    },

    refreshList() {
      this.$refs.picker.refreshList();
    },

    clearSelection() {
      this.$refs.picker.clearSelection();
    },

    close() {
      this.$refs.picker.close();
    },

    closePreview() {
      this.$refs.picker.closePreview();
    },

    openInNewTab(item) {
      let newPageRoute = this.$router.resolve({ name: 'MachineInfo', params: { machineId: item.Id } });
      window.open(newPageRoute.href, "_blank");
    },
  },

  computed: {
    PreviewCustomer() { return this.$store.getters["JobHub/JobPreview/PreviewCustomer"]; },

    mixedFilters() {
      const unitSorting = this.groupByUnitBool ? [{ Field: "UnitId", Direction: 1 }] : undefined;
      return { ...this.lockedFilters, Sort: unitSorting }
    },

    unitEnabled() {
      return this.$store.state.GlobalSettings.Features.UnitEnabled;
    },

    groupByUnitBool() {
      return this.lockedFilters?.CustomerId
        && this.unitEnabled
        && (!this.filters?.Sort || this.filters.Sort.length == 0);
    },

    groupByUnitFunction() {
      if (this.groupByUnitBool) {
        return (machine) => machine?.Unit ?? { Id: null, Name: this.$t("servicesystem.common_objects.unit.no_unit") };
      }
      else {
        return undefined;
      }
    }
  },

  watch: {},
};
</script>